export const isLightdashParameterOption = (opt) => typeof opt === 'object' && opt !== null && 'label' in opt && 'value' in opt;
export const DEFAULT_SPOTLIGHT_CONFIG = {
    default_visibility: 'show',
};
//# sourceMappingURL=lightdashProjectConfig.js.map